import React, { Component } from 'react'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  InputGroupText,
  Card,
  CardBody,
  CardFooter,
  Button,
  UncontrolledTooltip
} from 'reactstrap'
import { InputGroupAddon } from '@src/components/reactstrap-compat'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PerfectScrollbar from 'react-perfect-scrollbar'
import { ColumnsIcon, SearchIcon } from '@src/assets/icons'
//************************************//
import InputContainer from "@src/components/helpers/InputContainer"
import { trans } from '@utils'
//************************************//
class SelectColumns extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      search: '',
      options: this._formatOptions(props.columns),
      values: this._getValues()
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(this.state.options, this._formatOptions(this.props.columns))) {
      this.setState({
        options: this._formatOptions(this.props.columns),
        values: this._getValues()
      })
    }
  }
  _formatOptions = (columns) => {
    return _.map(_.filter(columns, c => c.showHide), c => {
      return {
        key: c.key || c.selector,
        value: c.selector,
        label: c.name,
        visible: c.visible
      }
    })
  }
  _getValues = () => {
    return _.map(_.filter(this.props.columns, c => c.showHide && !c.selected), c => {
      return { value: c.selector, label: c.name }
    })
  }
  _optionChange = (value) => {
    const find = _.find(this.state.values, v => v.value === value)
    if (find) {
      this.setState({
        values: _.filter(this.state.values, v => v.value !== value)
      })
    } else {
      const newValue = _.filter(this.state.options, o => o.value === value)
      this.setState({
        values: [...this.state.values, ...newValue]
      })
    }
  }
  _searchChange = (e) => {
    this.setState({
      search: e.target.value
    })
  }
  _searchRender = () => {
    return (
      <InputGroup className='input-group-merge mb-50'>
        <InputGroupAddon addonType='prepend'>
          <InputGroupText>
            <FontAwesomeIcon icon={SearchIcon} />
          </InputGroupText>
        </InputGroupAddon>
        <InputContainer type="uncontrolled-text" placeholder={trans('gen.actions.search')} className="form-control" onChange={this._searchChange} />
      </InputGroup>
    )
  }
  _optionsRender = () => {
    const options = _.filter(this.state.options, o => !o.visible && _.includes(_.lowerCase(o.label), _.lowerCase(this.state.search)))
    return _.size(options) ? (
      <PerfectScrollbar style={{ maxHeight: '200px' }}>
        <div className={'dropdown-items'}>
          {_.map(options, (option) => {
            const find = _.find(this.state.values, v => v.value === option.value)
            return (
              <div key={option.value} className={'dropdown-item d-flex'} style={{ zIndex: 0 }} onClick={(e) => this._optionChange(option.value)}>
                <InputContainer
                  type="checkbox"
                  id={option.value}
                  name={option.value}
                  value={option.value}
                  checked={find ? 1 : 0}
                  label={false}
                  className={'p-0'}
                  style={{ zIndex: 1 }}
                  onChange={() => { }}
                />
                <span className={'pl-2'}>{option.label}</span>
              </div>
            )
          })}
        </div>
      </PerfectScrollbar>
    ) : (
      <div className={'d-flex justify-content-center mt-1'}>
        {trans('gen.datatable.toolbar.selectColumn.noOptions')}
      </div>
    )
  }
  _onToggle = () => {
    if (this.state.isOpen) {
      this._onClose()
    } else {
      this._onOpen()
    }
  }
  _onOpen = () => {
    this.setState({ isOpen: true })
  }
  _onClose = () => {
    this.setState({
      isOpen: false,
      search: '',
      values: this._getValues()
    })
  }
  _onChange = () => {
    const selectedColumns = _.map(this.state.values, c => c.value)
    this.setState({
      isOpen: false,
      search: ''
    })
    this.props.onChange(selectedColumns)
  }
  //************************************//
  render() {
    return (
      <div>
        <Dropdown isOpen={this.state.isOpen} toggle={this._onToggle} direction={'down'}>
          <UncontrolledTooltip placement='top' target='react-dataTable-toolbar-columns'>
            {trans('gen.datatable.toolbar.selectColumn.columns')}
          </UncontrolledTooltip>
          <DropdownToggle color='flat-primary' size={'sm'} id={'react-dataTable-toolbar-columns'} className={'btn-toolbar'} disabled={this.props.disabled}>
            <FontAwesomeIcon icon={ColumnsIcon} />
          </DropdownToggle>
          <DropdownMenu className={'p-0'} right={true} flip={false}>
            <Card style={{ minWidth: '200px' }} className={'m-0'}>
              <CardBody className={'p-1'}>
                {this._searchRender()}
                {this._optionsRender()}
              </CardBody>
              <CardFooter className={'d-flex justify-content-end p-1'}>
                <Button color='flat-secondary' size='sm' onClick={() => this._onClose()} className={'mr-25'}>
                  {trans('gen.actions.cancel')}
                </Button>
                <Button color='primary' size='sm' onClick={this._onChange}>
                  {trans('gen.actions.apply')}
                </Button>
              </CardFooter>
            </Card>
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  }
}
//************************************//
export default SelectColumns
